import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import App from './App';
import './index.css';

// Suppress all console output in production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const antdTheme = {
  token: {
    colorPrimary: '#607afb',
    fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif',
  },
  components: {
    Layout: {
      bodyBg: '#f8f9fc',
      headerBg: '#ffffff',
    },
    Input: {
      colorBgContainer: '#e6e9f4',
      colorBorder: 'transparent',
      colorPrimaryHover: '#607afb',
      borderRadius: 8,
    },
    Button: {
      borderRadius: 8,
    },
  },
};

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider theme={antdTheme}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);
